<template>
  <b-row class="text-center mt-3">
    <b-col>
      <b-button :to="back"
                size="sm"
                variant="secondary"
                class="float-left"
        >
        <i class="fa fa-reply fa-lg"></i>
        Volver
      </b-button>
      <b-button type="submit"
                size="sm"
                variant="primary"
        >
        <i class="fa fa-floppy-o fa-lg"></i>
        Guardar
      </b-button>
      <b-button v-if="buttons.length !== 0" v-for="buttonF in buttons" :key="buttonF.key"
                type="button"
                size="sm"
                class="ml-1"
                :variant="buttonF.variant"
                v-b-modal="buttonF.ref"
      >
        <i :class="buttonF.class"></i>
        {{ buttonF.text }}
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'fds_footer_buttons',
  props: ['back','buttons']
}
</script>
